import dayjs, { Dayjs } from 'dayjs';
import { getDateRangeEnd } from './get-date-range-end';
import { getRangeDelta } from './get-range-delta';
import { TimeRange } from '@/shared/lib/utils/date-time/time-range';

const items = 250;
// const minStep = 1,
//   maxStep = 25000;
const roundToNearestMinute = function (date: Dayjs = dayjs(), minute: number) {
  const coeff = 1000 * 60 * minute; // <-- Replace {5} with interval
  return dayjs(Math.ceil((date.unix() * 1000) / coeff) * coeff);
};

/**
 * Шаг, при котором диапазон разобьётся не более чем на `points` отсчётов.
 *
 * Нужен виджетам, которым общий шаг из `getQueryRange` слишком мелкий:
 * столбчатой диаграмме 250 точек дают полотно в разы шире виджета. Меняется
 * только payload конкретного запроса, `items` остаётся общим для всех.
 */
export const getStepForPoints = (start: number, end: number, points: number) =>
  Math.max(1, Math.ceil(getRangeDelta(end, start) / Math.max(1, points)));

/** Resolve dates once, preserving milliseconds for ISO-based API requests. */
export const getQueryRangeDates = (range: TimeRange) => {
  const now = dayjs();
  return range?.type === 'absolute'
    ? {
        start: range.value?.[0] ? dayjs(range.value[0]) : now,
        end: getDateRangeEnd(range.value?.[1] ? dayjs(range.value[1]) : now),
      }
    : {
        start: now.subtract(+range?.value || 1, 'milliseconds'),
        end: now,
      };
};

export const getQueryRange = (range: TimeRange, round?: number) => {
  const { start, end } = getQueryRangeDates(range);
  return {
    start: round ? roundToNearestMinute(start, round).unix() : start.unix(),
    end: round ? roundToNearestMinute(end, round).unix() : end.unix(),
    step: Math.max(
      1,
      Math.floor(getRangeDelta(end.unix(), start.unix()) / items),
    ),
  };
};